import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Users from '../components/User/Users';
import * as UserActions from '../actions/User/actions';
import * as InstitutionActions from '../actions/Institution';
import { RootState } from '../store/configureStore';
import { Dispatch } from 'redux';

function mapStateToProps(state: RootState) {
  return {
    user: state.user,
    institution: state.institution.institution,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    userActions: bindActionCreators(UserActions, dispatch),
    institutionActions: bindActionCreators(InstitutionActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
